<template>
	<el-dialog title="谱例库" :visible.sync="visible" width="905px" :before-close="close" class="genealogy">
		<el-divider></el-divider>
		<div _pos="relative" _m="t-30px" _flex="~">
			<el-input placeholder="名称" v-model="input" @keyup.enter.native="search"></el-input>
			<i class="el-icon-search" _pos="absolute" _top="13px" _right="10px" _cursor="pointer" @click="search"></i>
		</div>
		<el-checkbox-group v-model="checkMusical" _m="t-18px">
			<el-checkbox
				v-for="item in musical"
				:label="item.val"
				:key="item.val"
				@change="checkMusicalChange($event, item)"
				>{{ item.name }}</el-checkbox
			>
		</el-checkbox-group>
		<div
			_m="t-35px l-15px"
			_p="b-30px"
			_grid="~ cols-6"
			_h="420px"
			_overflow="y-auto"
			_text="[#636363]"
			@scroll="wrapScrollHandler"
		>
			<div v-for="item in list" :key="item.id" _w="102px" _cursor="pointer" _m="b-32px" @click="selectId = item.id">
				<div
					_h="129px"
					_p="x-9px y-8px"
					_pos="relative"
					_transition="duration-300"
					:class="{ '!w-border-red-500': selectId == item.id }"
					_border="2px solid [#B6B6B6] rounded-6px rounded-tl-17px"
				>
					<img _w="full" _h="full" :src="require(`@/assets/image/score/${item.music_type}.png`)" draggable="false" />
					<!-- <span _pos="absolute" style="filter: blur(6px);height:16px" _text="12px bold [#565656] center" _bottom="3px" _left="0" _w="full" _bg="[rgba(255,255,255,0.63)]">hahahahhahhahah</span> -->

					<!-- :class="{ '!w-text-[#FF5E2A]': selectId == item.id }" -->
					<span
						_pos="absolute"
						_text="14px border"
						_bottom="0"
						_left="0"
						_h="29px"
						_flex="~ items-center justify-center"
						_w="full"
						_bg="[rgba(255,255,255,0.63)]"
						_border="1px solid [#F5F5F5] rounded-6px rounded-tl-17px"
						_box="border"
						style="backdrop-filter: blur(3px);"
					>
						{{ item.is_score_sync ? '谱音已同步' : '谱音未同步' }}
					</span>
				</div>
        <el-tooltip
          placement="bottom"
          effect="light"
          _w="full"
          _p="y-6px"
          _text="center 16px"
          _bg="[#EAEAEA]"
          _m="t-10px"
          _border="rounded-5px"
          _line="clamp-1"
          _transition="duration-300"
          :class="{ '!w-bg-[#FF5E2A] w-text-white': selectId == item.id }"
        >
          <div slot="content">{{ item.name }}</div>
          <div>{{ item.name }}</div>
        </el-tooltip>
			</div>
		</div>
		<el-divider></el-divider>
		<span slot="footer" _flex="~ justify-between">
			<el-button @click="newGenealogy" size="small">新建谱例</el-button>
			<el-button type="primary" size="small" @click="confirm">插入</el-button>
		</span>
	</el-dialog>
</template>
<script>
import { musical } from './const.js'
export default {
	model: {
		prop: 'visible',
		event: 'update:visible'
	},
	props: {
		visible: Boolean,
    questionType: {
      default: ''
    }
	},
	data() {
		return {
			musical,
			input: '',
			list: [],
			selectId: '',
			checkMusical: [],
			total: 0,
			page: 1
		}
	},
  watch: {
    questionType: {
      handler(val) {
        if (val != '' && this.$route.params.sbid == 1) {
          this.page = 1
          this.updateScoreList({ page: this.page, music_type: '' })
        }
      },
      immediate: true
    }
  },
	methods: {
		//获取Token
		GetToken() {
			let loadConfigStr = localStorage.getItem('tokenInfo')
			let loadConfig = null
			if (loadConfigStr) {
				loadConfig = JSON.parse(loadConfigStr)
			}
			return loadConfig.access_token
		},
		newGenealogy() {
			let accesstoken = this.GetToken()
			window.open(`${window.web_config.api_url}${window.web_config.music_score_editor_path}?token=${accesstoken}`)
		},
		close() {
			this.$emit('update:visible', false)
		},
    async confirm() {
      let isComfirm = false
      // 5 视唱旋律题  9 演唱题
      if ([5, 9].includes(this.questionType)) {
        // const musicalInfo = await getMusicalInfo(this.selectId)
        const item = this.list.find(item => item.id == this.selectId)
        const music = item.music
        if (music && music.length) {
          const name = this.questionType === 5 ? '视唱旋律题' : '演唱题'
          const str = `当前谱子没有设置谱子的预备拍，请前往谱例管理中的谱音同步器设置谱子的预备拍，如果不设置可能导致${name}无法使用，是否继续插入？`
          try {
            for (let i = 0; i < music.length; i++) {
              const new_timeline = music[i].new_timeline;
              if(new_timeline === '') continue
              const new_timeline_data = JSON.parse(new_timeline);
              const NODELINE_WXP_data = JSON.parse(new_timeline_data.NODELINE_WXP);
              if (!NODELINE_WXP_data.some(x => x.meter_data)) {
                // 不存在预备拍
                isComfirm = await this.$confirm(str, '注意', {
                  confirmButtonText: '继续',
                  cancelButtonText: '取消',
                  type: 'warning'
                })
                if(!isComfirm) return
              }
              console.log("new_timeline_data", new_timeline_data)
              console.log("NODELINE_WXP_data", NODELINE_WXP_data)
            }
          } catch (error) {
            if (error === 'cancel') isComfirm = false
            console.log("error", error)
            if (!isComfirm) return
          }
        }
      }
			const item = this.list.find(item => item.id == this.selectId)
			if (!item.is_score_sync && ![4, 18, 5, 24].includes(this.questionType)) {
				this.$message.error('请选择谱音同步的谱例')
				return
			}
			this.$emit('update:visible', false)
			this.$emit('select', { selectId: this.selectId, name: item.name })
		},
		checkMusicalChange(event, item) {
			if (item.name == '全部') {
				if (event) {
					this.checkMusical = []
					this.checkMusical.push(this.musical[0].val)
				} else {
					this.checkMusical.splice(0, this.checkMusical.length)
				}
			} else {
				this.checkMusical = this.checkMusical.filter(item => {
					return item !== ''
				})
			}
			this.updateScoreList({ page: 1, music_type: this.checkMusical.join(',') })
		},
		async search() {
			this.updateScoreList({ page: 1, music_type: this.checkMusical.join(',') })
		},
		async wrapScrollHandler(e) {
			const el = e.target
			const { scrollTop, clientHeight, scrollHeight } = el
			const total = scrollTop + clientHeight
			if (total === scrollHeight) {
        const { data, meta } = await this.$api.bureau.ScoreList({
				// const { data, meta } = await this.$api.question_set.getMusicals({
					fu_name: this.input,
					page: this.page + 1,
					page_size: 20,
					music_type: this.checkMusical.join(','),
					is_private: 2, // 2是代表能插入自己平台导入的所有曲谱
          is_all: this.questionType == 4 ? true : ''
				})
				this.page = meta.current_page
				this.list = [...this.list, ...data]
				this.total = meta.total
			}
		},
		async updateScoreList(params) {
      const { data, meta } = await this.$api.bureau.ScoreList({
			// const { data, meta } = await this.$api.question_set.getMusicals({
				fu_name: this.input,
				page: params.page,
				page_size: 20,
				music_type: params.music_type,
				is_private: 2,
        is_all: this.questionType == 4 ? true : ''
			})
			this.list = data
			this.page = meta.current_page
			this.total = meta.total
		}
	},
}
</script>
<style lang="scss" scoped>
.genealogy {
	/deep/ .el-dialog__header {
		padding-bottom: 0px !important;
	}
}
</style>
